import BurgerMenuMobileView from './mobile/BurgerMenu.mobile.view';
import type BurgerMenuProperties from './BurgerMenu.properties.ts';
import { useIsMobileDevice } from '../../tools/hooks/useIsMobileDevice.ts';

export default function BurgerMenuView(props: BurgerMenuProperties) {
  const isMobile = useIsMobileDevice();

  return <>{isMobile && <BurgerMenuMobileView {...props} />}</>;
}
